// Where to go after signing in when another product sent the user here
// (Sunday task 1732). /sso/authorize sends a signed-out browser to
// /ops/login?continue=/sso/authorize?...; the sign-in pages keep that target
// across the password and two-factor steps and hand the browser back to it.
//
// Only our own authorize endpoint is accepted, so ?continue= can never send
// someone to another site. The server checks again when the URL is opened.

const KEY = "helix-sso-continue";

export function safeSsoContinue(raw: string | null | undefined): string | null {
  if (!raw || !raw.startsWith("/sso/authorize?")) return null;
  if (raw.includes("\\") || raw.includes("//") || /[\r\n]/.test(raw)) return null;
  return raw;
}

/** Call on the sign-in page: remember ?continue= for after sign-in. */
export function rememberSsoContinue(search: string): void {
  const target = safeSsoContinue(new URLSearchParams(search).get("continue"));
  if (!target) return;
  try {
    sessionStorage.setItem(KEY, target);
  } catch {
    /* storage blocked: the user lands on Helix and reopens the product */
  }
}

/** Call once signed in. True when the browser is on its way to the product. */
export function resumeSsoContinue(): boolean {
  let target: string | null = null;
  try {
    target = safeSsoContinue(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
  } catch {
    return false;
  }
  if (!target) return false;
  window.location.assign(target);
  return true;
}
